import ReactOnRails from 'react-on-rails';

import AlgoliaInsightsTracker from '@javascript/vehicle_product/instant_search/algoliaInsightsTracker';
import BannerService from '@javascript/components/application/banners/bannerService';
import ColourTabsContainer from '@javascript/vehicle_product/pre_reg/colourTabsContainer';
import DisclaimerWrapper from '@javascript/vehicle_product/disclaimer/disclaimerWrapper';
import EnquiryParams from '@javascript/vehicle_product/enquiryParams';
import ExternalScriptHelper from '@components/helpers/externalScriptHelper';
import FeedbackContainer from '@components/feedback/feedbackContainer';
import FinanceContainer from '@javascript/vehicle_product/finance/financeContainer';
import GalleryTrigger from '@components/application/galleryTrigger';
import LazyLoader from '@components/helpers/lazyLoader';
import LiveChatButton from '@javascript/vehicle_product/header/liveChatButton';
import OurRecommendationsShowcaseContainer from '@javascript/vehicle_product/instant_search/ourRecommendationsShowcaseContainer';
import ProductPageContainer from '@javascript/vehicle_product/productPageContainer';
import RecentlyViewedHelper from '@components/helpers/recentlyViewedHelper';
import ShareButton from '@javascript/vehicle_product/header/shareButton';
import ShortlistButton from '@components/shortlist/shortlistButton';
import SimilarVehiclesCta from '@javascript/vehicle_product/similarVehiclesCta';
import SpecificationContainer from '@javascript/vehicle_product/specification/specificationContainer';
import StockAlertLauncher from '@components/stock_alerts/stockAlertLauncher';
import VehicleShowcase from '@components/vehicle_showcase/vehicleShowcase';
import WhatsAppButton from '@javascript/vehicle_product/header/whatsAppButton';
import WistiaVideo from '@javascript/vehicle_product/wistiaVideo';

// Shared components
import AccountListener from '@components/account/accountListener';
import FinanceLightboxWithModal from '@components/finance/financeLightboxWithModal';
import GalleryWrapper from '@components/gallery/galleryWrapper';
import Toast from '@components/application/toast';

ReactOnRails.register({
  AlgoliaInsightsTracker,
  BannerService,
  ColourTabsContainer,
  DisclaimerWrapper,
  EnquiryParams,
  ExternalScriptHelper,
  FeedbackContainer,
  FinanceContainer,
  GalleryTrigger,
  LazyLoader,
  LiveChatButton,
  OurRecommendationsShowcaseContainer,
  ProductPageContainer,
  RecentlyViewedHelper,
  ShareButton,
  ShortlistButton,
  SimilarVehiclesCta,
  SpecificationContainer,
  StockAlertLauncher,
  VehicleShowcase,
  WhatsAppButton,
  WistiaVideo,
  // Shared components
  AccountListener,
  FinanceLightboxWithModal,
  GalleryWrapper,
  Toast,
});
